import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import Head from 'next/head';
import agent from '../utils/agent';
import Router from 'next/router'
import storage from "../utils/storage";
import {isWeixinBrowser} from "../utils/utils";
import {Modal, Toast} from "antd-mobile";

const PageWrapper = (ComposedComponent) => {
    class AppLayout extends Component {

        state = {
        };

        constructor(props) {
            super(props);
        }

        static async getInitialProps({res, query}) {
            return {
                query
            };
        }

        async componentDidMount() {
            // const {query} = this.props;
            // try {
            //     const userInfo = storage.MpUserInfo.get();
            //     const isWeixin = isWeixinBrowser();
            //     if (userInfo) {
            //         const channelUser = await agent.ChannelUser.findByUser(userInfo.id);
            //         if (channelUser) {
            //             const {pathname} = location;
            //             if (channelUser.channelId) {
            //                 if (pathname.startsWith('/pay/apply')) {
            //                     console.log('apply', query);
            //                     Router.replace({
            //                         pathname: '/pay/submit',
            //                         query
            //                     });
            //                 }
            //             }
            //         }
            //     }
            //     if (isWeixin) {
            //         const data = await agent.Wechat.getConfig();
            //         data.jsApiList = [
            //             'chooseWXPay',
            //             'previewImage',
            //         ];
            //         wx.config(data);
            //         wx.checkJsApi({
            //             jsApiList: ['chooseWXPay', 'previewImage'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
            //             success: function (res) {
            //             }
            //         });
            //     }
            //
            // } catch (e) {
            //     console.log(e);
            // } finally {
            // }
        }

        render() {
            return (
                <div>
                    <ComposedComponent {...this.props} />
                </div>
            );
        }
    }

    return AppLayout;
};

export default PageWrapper;
